if (!customElements.get('product-message')) {
  class ProductMessage extends HTMLElement {
    static LocalStorageKey = 'card_message';

    constructor() {
      super();
    }

    setValueToLocalStorage(value) {
      localStorage.setItem(ProductMessage.LocalStorageKey, value);
    }

    updateLength(value) {
      this.currentElement.textContent = value.length;
    }

    handleInput(event) {
      const value = event.target.value;

      this.updateLength(value);
      this.setValueToLocalStorage(value);
    }

    connectedCallback() {
      this.characterLimit = this.getAttribute('js-limit');

      this.currentElement = this.querySelector('[js-current]');
      this.textarea = this.querySelector('textarea');

      this.textarea.addEventListener('input', this.handleInput.bind(this));

      this.textarea.value = localStorage.getItem(
        ProductMessage.LocalStorageKey,
      );
      this.updateLength(this.textarea.value);
    }
  }

  customElements.define('product-message', ProductMessage);
}
